import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const LangGroup = styled(ToggleButtonGroup)(() => ({
  background: 'var(--bar-bg)',
  borderRadius: 20,
  padding: 2,
  gap: 2,
  '& .MuiToggleButtonGroup-grouped': {
    border: '0 !important',
    borderRadius: '18px !important',
    margin: 0,
  },
}));

const LangBtn = styled(ToggleButton)(() => ({
  fontSize: '11.5px',
  fontWeight: 600,
  fontFamily: 'inherit',
  padding: '3px 11px',
  color: 'var(--muted)',
  textTransform: 'none',
  lineHeight: 1.5,
  minWidth: 38,
  letterSpacing: '0.04em',
  transition: 'background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease',
  '&:hover:not(.Mui-selected)': {
    background: 'var(--hover)',
    color: 'var(--text)',
  },
  '&.Mui-selected': {
    background: 'var(--accent)',
    color: '#fff',
    boxShadow: '0 1px 6px rgba(79,70,229,0.35)',
    '&:hover': {
      background: 'var(--accent)',
      color: '#fff',
    },
  },
}));

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const lang = i18n.language?.startsWith('ja') ? 'ja' : 'en';

  const handleChange = (_, newLang) => {
    if (!newLang) return;
    i18n.changeLanguage(newLang);
    try { localStorage.setItem('ci_lang', newLang); } catch { /* ignore */ }
  };

  return (
    <LangGroup
      value={lang}
      exclusive
      onChange={handleChange}
      aria-label={t('language.switcher')}
      size="small"
    >
      <LangBtn value="en" aria-label={t('language.english')}>EN</LangBtn>
      <LangBtn value="ja" aria-label={t('language.japanese')}>JP</LangBtn>
    </LangGroup>
  );
}
